<!--用户组的树-->
<template>
	<baseTree ref="treeBean" :baseTreeStyle='{}' :dataList="dataList" :groupCheckAble="groupCheckAble" :autoSelectMethod="autoSelectMethod"
	 :typeImgNameList="typeImgNameList" :getTypeImgIndex="getTypeImgIndex" :isGroup="isGroup" :isSameItem="isSameItem"
	 :isDisAble="isDisAble" @checkItem="$emit('checkItem', $event)" :getIDMethod="getIDMethod" :getCheckImgIndex="getCheckImgIndex"
	 :loadMore="loadMore" :checkShowAble="checkShowAble" :multiSelect="multiSelect" :checkImgNameList="checkImgNameList" :defaultValue="defaultValue"
	 @loadMoreMethod="loadMoreMethod" :labelStyle='labelStyle' :getLabelMethod="getLabelMethod"> </baseTree>
</template>

<script>
	import baseTree from '@/components/module/tree/baseTree.vue'
	import imageView from '@/components/module/universal/imageView.vue'
	export default {
		components: {
			baseTree,
			imageView,
		},
		props: {
			defaultValue:{
				type: Array,
				default: undefined
			},
			isDisAble: {
				type: Function,
				default: () => {
					return false
				}
			},
			labelStyle: {
				type: Object,
				default: undefined
			},
			checkShowAble: {
				type: Function,
				default (item, index) {
					return this.groupCheckAble ? (this.multiSelect) : (!this.isGroup(item) && this.multiSelect)
				}
			},
			isGroup: {
				type: Function,
				default (item, index) {
					return item.type == 'UsePowerUnit' || item.type == 'WosUserGroup'
				}
			},
			isUnit: {
				type: Function,
				default (item, index) {
					return item.type == 'UsePowerUnit'
				}
			},
			loadMoreMethod: {
				type: Function,
				default (that) {}
			},
			multiSelect: {
				type: Boolean,
				default: false
			},
			loadMore: {
				type: Boolean,
				default: false
			},
			//数据源，可查看设备树或者啥的
			dataList: {
				type: Array,
				required: true,
			},
			//默认选中的方法,接收到数据源的时候，会递归设备树，然后根据这个方法找到第一个符合条件的项，设置为选中项，但是会根据是否允许选中单位来做过滤，如果不允许选中单位组，返回true也无效
			autoSelectMethod: {
				type: Function,
				default (item, index) {
					//默认是找到第一个设备
					return item.next == undefined
				}
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			groupCheckAble: {
				type: Boolean,
				default: false
			},
			isSameItem: {
				type: Function,
				default (item, nowItem) {
					if (nowItem == undefined || item == undefined) {
						return item == nowItem
					}
// 					if (this.isGroup(nowItem) != this.isGroup(item)) {
// 						return false
// 					}
					return nowItem.id == item.id
				}
			},
			getIDMethod: {
				type: Function,
				default (item) {
					return item.id
				}
			},
			getLabelMethod: {
				type: Function,
				default (item) {
					return item.name ? item.name : item.username
				}
			},


		},
		data() {
			return {
				typeImgNameList: [
					'tree/node_unit.png', 'tree/node_class.png', 'tree/node_dev.png',
					'tree/node_unit_select.png', 'tree/node_class_select.png', 'tree/node_dev_select.png',
				],
				index: 1,
				checkImgNameList: ['checkBox/checked.png', 'checkBox/unchecked.png']
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			getCheckImgIndex(item, datas) {
				if (datas == undefined || !this.multiSelect) {
					return 1
				} else {
					return datas.indexOf(item) > -1 ? 0 : 1
				}
			},
			getTypeImgIndex(item) {
				var treeB = this.$refs.treeBean
				if (treeB == undefined) {
					treeB = {}
				}
				var nowData = treeB.nowCheckItem ? treeB.nowCheckItem : this.multiSelect ? [] : {}
				if (this.multiSelect) {
					if (nowData.includes(item)) {
						if (this.isUnit(item)) {
							return 3
						}
						if (this.isGroup(item)) {
							return 4
						}
						return 5
					} else {
						if (this.isUnit(item)) {
							return 0
						}
						if (this.isGroup(item)) {
							return 1
						} 
						return 2
					}
				} else {
					if (this.isSameItem(item, nowData)) {
						if (this.isUnit(item)) {
							return 3
						}
						if (this.isGroup(item)) {
							return 4
						}  
						return 5
					} else {
						if (this.isUnit(item)) {
							return 0
						}
						if (this.isGroup(item)) {
							return 1
						}  
						return 2
					}
				}

			},
			setNowCheckItem(item) {
				this.$refs.treeBean.nowCheckItem = item
			},

		}
	}
</script>

<style scoped>
</style>
